"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftSearchDto = instanceOfShiftSearchDto;
exports.ShiftSearchDtoFromJSON = ShiftSearchDtoFromJSON;
exports.ShiftSearchDtoFromJSONTyped = ShiftSearchDtoFromJSONTyped;
exports.ShiftSearchDtoToJSON = ShiftSearchDtoToJSON;
exports.ShiftSearchDtoToJSONTyped = ShiftSearchDtoToJSONTyped;
const State_1 = require("./State");
const ShiftType_1 = require("./ShiftType");
const ShiftTime_1 = require("./ShiftTime");
/**
 * Check if a given object implements the ShiftSearchDto interface.
 */
function instanceOfShiftSearchDto(value) {
    return true;
}
function ShiftSearchDtoFromJSON(json) {
    return ShiftSearchDtoFromJSONTyped(json, false);
}
function ShiftSearchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'startFromRecord': json['startFromRecord'] == null ? undefined : json['startFromRecord'],
        'profileId': json['profileId'] == null ? undefined : json['profileId'],
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'specialtyCodes': json['specialtyCodes'] == null ? undefined : json['specialtyCodes'],
        'preferredShifts': json['preferredShifts'] == null ? undefined : (json['preferredShifts'].map(ShiftTime_1.ShiftTimeFromJSON)),
        'minimumPayRate': json['minimumPayRate'] == null ? undefined : json['minimumPayRate'],
        'jurisdictions': json['jurisdictions'] == null ? undefined : (json['jurisdictions'].map(State_1.StateFromJSON)),
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'radiusInMiles': json['radiusInMiles'] == null ? undefined : json['radiusInMiles'],
        'facilities': json['facilities'] == null ? undefined : json['facilities'],
        'shiftTypes': json['shiftTypes'] == null ? undefined : (json['shiftTypes'].map(ShiftType_1.ShiftTypeFromJSON)),
    };
}
function ShiftSearchDtoToJSON(json) {
    return ShiftSearchDtoToJSONTyped(json, false);
}
function ShiftSearchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'startFromRecord': value['startFromRecord'],
        'profileId': value['profileId'],
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString()),
        'endDate': value['endDate'] == null ? undefined : ((value['endDate']).toISOString()),
        'specialtyCodes': value['specialtyCodes'],
        'preferredShifts': value['preferredShifts'] == null ? undefined : (value['preferredShifts'].map(ShiftTime_1.ShiftTimeToJSON)),
        'minimumPayRate': value['minimumPayRate'],
        'jurisdictions': value['jurisdictions'] == null ? undefined : (value['jurisdictions'].map(State_1.StateToJSON)),
        'lat': value['lat'],
        'lng': value['lng'],
        'radiusInMiles': value['radiusInMiles'],
        'facilities': value['facilities'],
        'shiftTypes': value['shiftTypes'] == null ? undefined : (value['shiftTypes'].map(ShiftType_1.ShiftTypeToJSON)),
    };
}
//# sourceMappingURL=ShiftSearchDto.js.map